import { ItdsMode } from '@reliance/types/enums/ItdsMode';
import { InmateImportMode } from '@reliance/types/enums/InmateImportMode';
import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';

type GeneralDetailsProps = {
  facility: Facility;
};

const formatInmateImportMode = (inmateImportMode: InmateImportMode) => {
  switch (inmateImportMode) {
    case InmateImportMode.ITDS: return 'ITDS';
    case InmateImportMode.GENERIC: return 'Generic';
    case InmateImportMode.GENERIC_NUMERIC_TRANSFORM_ACCOUNT: return 'GenericNumericTransformAccount';
    case InmateImportMode.JAILTRACKER: return 'JailTracker';
    case InmateImportMode.TURNKEY: return 'TurnKey';
    case InmateImportMode.BLU_HORSE: return 'BluHorse';
    case InmateImportMode.CPC: return 'CPC';
    default: return 'N/A';
  }
};

const formatItdsMode = (itdsMode: ItdsMode) => {
  if (itdsMode === ItdsMode.DISABLED) {
    return 'Disabled';
  }
  if (itdsMode === ItdsMode.FULL) {
    return 'Full';
  }
  return 'Legacy';
};

const GeneralDetails: React.FC<GeneralDetailsProps> = (props) => {
  const { facility } = props;

  return (
    <Card>
      <Card.Header>Overview</Card.Header>
      <Card.Body>
        {facility.name}<br/>
        {facility.address}<br/>
        {facility.city}, {facility.state} {facility.zip}<br/><br/>

        County: {facility.county || 'N/A'}<br/>
        Timezone: {facility.timezone || 'N/A'}<br/>
        External System ID: {facility.externalId || 'N/A'}<br/><br/>

        Type: {facility.facilityType}<br/>
        Import Mode: {formatInmateImportMode(facility.inmateImportMode)}<br/>
        ITDS Mode: {formatItdsMode(facility.itdsMode)}<br/><br/>

        Latitude/Longitude:<br/>
        {facility.latitude}<br/>
        {facility.longitude}
      </Card.Body>
    </Card>
  );
};

export default GeneralDetails;
